import axios from "axios";

const collection = document.querySelector(".js-page-collection");

if (collection !== null) {

    //Infinite load
    const collectionWrapper = document.querySelector(".js-collection");
    const collectionPage = document.querySelector(".js-page-collection");
    const collectionProductsGrid = collectionPage.querySelector(".js-collection-products-grid");

    let isLoading = false;
    const windowScrollHandler = async () => {

        const {bottom} = collectionProductsGrid.getBoundingClientRect();
        const {innerHeight} = window;
        const {dataset: {current, pages, next}} = collectionWrapper;

        if (!isLoading && +current < +pages && (bottom - (innerHeight)) <= 0) {

            isLoading = true;
            collectionWrapper.setAttribute('data-loading', '');

            const {status, data} = await axios.get(next);

            if (status === 200) {
                const parser = new DOMParser();
                const html = parser.parseFromString(data, 'text/html');
                const {dataset} = html.querySelector('.js-collection');
                const newProductsGrid = html.querySelector('.js-collection-products-grid');
                const newProductBlocks = [].slice.call(newProductsGrid.children)
                    .filter(element => !element.classList.contains('collections__navigation'));

                collectionWrapper.setAttribute('data-current', dataset.current);
                collectionWrapper.setAttribute('data-pages', dataset.pages);
                collectionWrapper.setAttribute('data-next', dataset.next);

                // Filter out elements with collections__navigation class before appending
                const elementsToAppend = [].slice.call(newProductsGrid.children)
                    .filter(element => !element.classList.contains('collections__navigation'));

                collectionProductsGrid.append(...elementsToAppend);

                newProductBlocks.map(product => {
                    //productblockHandler(product);
                });

               collectionWrapper.removeAttribute('data-loading');

                setTimeout(() => {
                    isLoading = false;
                }, 500);
            }
        }
    };
    window.addEventListener('scroll', windowScrollHandler);


    const uspsBar = collection.querySelector('.js-collection-usps');
    const container = document.querySelector('.js-collection-products-grid');
    const items = Array.from(container.querySelectorAll('.productblock__wrapper'))
        .filter(item => !item.classList.contains('full-width'));

    let variableCount = 16;
    let index = 1;

    if (window.innerWidth < 1024) {
        index = 2;
    }

    // Voeg na elke 16 items een extra element toe
    items.forEach((item, ) => {

        if (index === variableCount) {

            const extraElement = document.createElement('div');
            extraElement.classList.add('collection-usps');
            extraElement.innerHTML = uspsBar.innerHTML;
            container.insertBefore(extraElement, item.nextSibling);
            variableCount = 16;
            index = 0;

        }
        index++;

    });

    const showMore = collection.querySelector('.js-show-more-toggle');
    const sideBar = collection.querySelector('.webshop-sidebar');

    // showMore.addEventListener('click', () => {
    //     sideBar.classList.toggle('active');
    //     if(sideBar.classList.contains('active')) {
    //         showMore.innerHTML = showMore.dataset.less;
    //     } else {
    //         showMore.innerHTML = showMore.dataset.more;
    //     }
    // });
}
